import React from "react"

// Components
import StyledCard from "../../Global/StyledCard/StyledCard"

// Styles
import styles from "./industries.module.sass"

// Icons
import LogisticsIcon from "../../../icons/servicesPage/industries/logistics.svg"
import FintechDeFiIcon from "../../../icons/servicesPage/industries/fintechDeFi.svg"
import RetailIcon from "../../../icons/servicesPage/industries/retail.svg"
import InsuranceIcon from "../../../icons/servicesPage/industries/Saas.svg"
import CryptocurrencyIcon from "../../../icons/servicesPage/industries/cryptocurrency.svg"
import GovermentIcon from "../../../icons/servicesPage/industries/defi.svg"
import CrmErmSystemsIcon from "../../../icons/servicesPage/industries/crm-erm-systems.svg"

// Content
const industriesArr = [
  {
    id: 0,
    title: `Logistics`,
    description: `Optimize your business with CRM/ERP and Supply Chain to become a new big player.`,
    icon: <LogisticsIcon />,
  },
  {
    id: 1,
    title: `Fintech`,
    description: `Outsource of fintech development is an optimal solution for companies that require technically complex business software development.`,
    icon: <FintechDeFiIcon />,
  },
  {
    id: 2,
    title: `DeFi`,
    description: `Recreate traditional financial instruments in a decentralized architecture, outside of corporate and governmental control.`,
    icon: <GovermentIcon />,
  },
  {
    id: 3,
    title: `Retail`,
    description: `Full custom solutions for your business when SaaS and standard solutions are not enough.`,
    icon: <RetailIcon />,
  },
  {
    id: 4,
    title: `SaaS`,
    description: `Software as a service app development requires a specific approach. Our team knows how to build services that will get thousands of customers on a hook.`,
    icon: <InsuranceIcon />,
  },
  {
    id: 5,
    title: `Cryptocurrency`,
    description: `The future is decentralized. Are you Blockchain Ready? We are willing to assist you in developing your own digital assets.`,
    icon: <CryptocurrencyIcon />,
  },
  {
    id: 6,
    title: `CRM-ERP systems`,
    description: `Achieve your customer engagement objectives with a customized and scalable CRM or ERP system without a separate license for each new user.`,
    icon: <CrmErmSystemsIcon />,
  },
]

const IndustriesScreen = () => {
  return (
    <section className={"section"}>
      <div className="container">
        <div className="row v-center space-between flex-wrap">
          <div className={"heading"}>
            <h2>Industries</h2>
            <p>
              You underestimate the power of the Mad Side ©Darth Vader
            </p>
          </div>
          <div className={styles.wrapper}>
            {industriesArr.map(ind => (
              <div className={styles.card} key={ind.id}>
                <StyledCard type="reverse">
                  <div className={styles.content}>
                    <div className={styles.icon}>{ind.icon}</div>
                    <div>
                      <h3>{ind.title}</h3>
                      <p>{ind.description}</p>
                    </div>
                  </div>
                </StyledCard>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default IndustriesScreen
